import * as Yup from "yup";
import checkout from "./form2";

const {
  formField2: {
    countryName,
    airlinesName,
    startDate,
    endDate,
    supplementaryForThe,
    firstTime,
    vehicleName,
    taxAgencyId,
    taxAgencyName,
    agencyId,
    agencyName,
  },
} = checkout;

const validation2 = Yup.object().shape({
  [vehicleName.name]: Yup.string().required(vehicleName.errorMsg),
  [countryName.name]: Yup.string().required(countryName.errorMsg),
  [airlinesName.name]: Yup.string().required(airlinesName.errorMsg),
  [startDate.name]: Yup.number().required(startDate.errorMsg),
  [endDate.name]: Yup.number().required(endDate.errorMsg),
  [firstTime.name]: Yup.string().required(firstTime.errorMsg),
  [supplementaryForThe.name]: Yup.string()
  .matches(/^\d+$/, supplementaryForThe.invalidMsg)
  .required(supplementaryForThe.errorMsg),
  [taxAgencyId.name]: Yup.string()
  .matches(/^\d{10}(?:-\d{3})?$/, taxAgencyId.invalidMsg)
  .required(taxAgencyId.errorMsg),
  [taxAgencyName.name]: Yup.string().optional(),
  [agencyName.name]: Yup.string().required(agencyName.errorMsg),
  [agencyId.name]: Yup.string()
    .matches(/^\d{10}(?:-\d{3})?$/, agencyId.invalidMsg)
    .required(agencyId.errorMsg),

});

export default validation2;
